import React, { useEffect, useState } from "react";
import HeaderLogado from "../../../components/common/Authenticated/Header/HeaderLogado";
import BottomMenu from "../../../components/common/Authenticated/Menu/Menu";
import Atendimento from "../../../components/Authenticated/Home/Atendimento";
import api from "../../../services/api";
import consts from "../../../consts.js";
import LoadingComponent from "../../../components/common/LoadingComponent.js";

function HomeAuthenticated() {
    const [servicos, setServicos] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchServicos = async () => {
            try {
                setLoading(true);
                const { data } = await api.get(`servico/salao/${consts.salaoId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!data.error) {
                    setServicos(data.servicos);
                } else {
                    console.error(data.message);
                }
            } catch (err) {
                console.error("Erro ao buscar serviços:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchServicos();
    }, [consts.salaoId, token]);

    return (
        <>
            <HeaderLogado />
            <div className="p-5 space-y-1 bg-white min-h-svh">
                <div className="flex items-baseline space-x-1">
                    <h2 className="text-black text-4xl md:text-4xl font-bold m-2 ml-0">Olá, </h2>
                    <h2 className="text-[#003D42] text-4xl md:text-4xl font-bold m-1">
                        {localStorage.getItem("usuario")
                            ? JSON.parse(localStorage.getItem("usuario")).nome.split(" ")[0]
                            : "Usuário"}!
                    </h2>
                </div>
                <h3 className="text-black text-2xl md:text-2xl font-bold">Como podemos te ajudar?</h3>
                <h3 className="text-[#7e7e7e] text-xl md:text-xl font-bold">
                    Escolha o tipo de atendimento que você precisa.
                </h3>

                <div
                    className="grid grid-cols-1 md:grid-cols-4 gap-2 md:gap-4 overflow-y-auto border w-full max-w-full pb-24"
                    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                    {loading ? (
                        <LoadingComponent/>
                    ) : servicos?.length > 0 ? (
                        servicos.map((servico) => (
                            <Atendimento
                                key={servico._id}
                                titulo={servico.titulo}
                                subtitulo={servico.descricao || "Descrição não disponível"}
                                imagem={
                                    servico.arquivos && servico.arquivos[0]
                                        ? `${consts.bucketUrl}/${servico.arquivos[0].caminho}`
                                        : "https://kennydouglas.com.br/wp-content/uploads/2023/07/Fotografia-de-paisagem-guia-comp.webp"
                                }
                                id={servico._id}
                            />
                        ))
                    ) : (
                        <p className="text-gray-500 col-span-full text-center">
                            Nenhum serviço disponível
                        </p>
                    )}
                </div>
            </div>
            <BottomMenu />
        </>
    );
}

export default HomeAuthenticated;